import { CamelCasedPropertiesDeep } from 'type-fest';
import { z } from 'zod/v4';
import { createDefinitionSchema } from '../../utils/helpers';

/**
 * Type for the spec-driven `DashboardPanel` variant of the markdown panel.
 */
export interface MarkdownPanelSpec extends z.TypeOf<typeof markdownPanelSpecSchema> {}

/**
 * Zod schema for the spec-driven `DashboardPanel` variant of the markdown panel.
 */
export const markdownPanelSpecSchema = z.object({
  text: z.string(),
});

/**
 * The schema for a Markdown `DashboardPanel` definition.
 */
export interface MarkdownPanelDefinition extends z.TypeOf<typeof markdownPanelDefinitionSchema> {}
// markdownPanelSchema is a schema for a Markdown panel, which essentially implements Definition<MarkdownPanelSpec, 'Markdown'>.
export const markdownPanelDefinitionSchema = createDefinitionSchema('Markdown', markdownPanelSpecSchema);

/**
 * Version of the Zod schema to be used for base types for the props-driven `Viz` variant of the markdown panel.
 *
 * Currently, it is the same as the spec-driven variant, but it may need to change in the future to
 * do things like flatten a specific property or some other transform (examples can be found in pie chart).
 */
export const markdownVizSchema = markdownPanelSpecSchema;

/**
 * Base type for the props-driven `Viz` variant of the markdown panel generated from the Zod schema and
 * converting all snake_case properties to camelCase. This interface should be extended in `viz-framework`
 * to do the following:
 * - Add additional types for `Viz` only use cases.
 * - Extend properties to add more meaningful jsdoc. This is necessary because both `z.Typeof` and
 *   `CamelCasedPropertiesDeep` lose jsdoc.
 */
export interface MarkdownPanelPropsBase extends CamelCasedPropertiesDeep<z.TypeOf<typeof markdownVizSchema>> {}
